import { render, staticRenderFns } from "./TermsTemplateNotice.vue?vue&type=template&id=51e75c49&scoped=true&"
import script from "./TermsTemplateNotice.vue?vue&type=script&lang=ts&"
export * from "./TermsTemplateNotice.vue?vue&type=script&lang=ts&"
import style0 from "./TermsTemplateNotice.vue?vue&type=style&index=0&id=51e75c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e75c49",
  null
  
)

export default component.exports